// src/utils/storage.js
export const LS_LOGIN = 'auth_data';

const storage = {
    set: (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        if(key === LS_LOGIN){  
        sessionStorage.setItem(LS_LOGIN, JSON.stringify(value));
        }
      } catch (err) {
        console.error('LocalStorage Set Error:', err);
      }
    },
  
    get: (key) => {
      try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
      } catch (err) {
        console.error('LocalStorage Get Error:', err);
        return null;
      }
    },
  
    remove: (key) => {
      try {
        localStorage.removeItem(key);
        if(key === LS_LOGIN){  
          sessionStorage.removeItem(LS_LOGIN);
        }
      } catch (err) {
        console.error('LocalStorage Remove Error:', err);
      }
    },
  
    clear: () => {
      try {
        localStorage.clear();
        sessionStorage.clear();
      } catch (err) {
        console.error('LocalStorage Clear Error:', err);
      }
    },
  };
  
  export default storage;
  